import { deleteTelegramBotConnections, getTelegramBotConnections } from '@app/packages/api/v2/actions/telegram_bot_connections'

import { removeTelegramBotConnectionSlice } from '@app/store/selectors/telegram'
import { createThunk } from '@app/store/thunk'

import { callV2Api } from './api'
import { loginAndStore } from './session'

export const clearTelegramBotConnections = () => {
  return createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(getTelegramBotConnections()))
    await Promise.all(
      resp.data.map(async connection => {
        await dispatch(callV2Api(deleteTelegramBotConnections(connection.id)))
        dispatch(removeTelegramBotConnectionSlice(connection.id))
      })
    )
  })
}

/** Only signs in an account that already has this Telegram bound; it never creates one. */
export function loginWithTelegram(bot: string, auth_data: Telegram.AuthData) {
  return createThunk(async dispatch => {
    await dispatch(loginAndStore({ method: 'telegram', bot, auth_data }))
  })
}
